import React from 'react'

const useRadioGroup = () => {
    const data = [
        {
            id: '1',
            name: 'Button',
        },
        {
            id: '2',
            name: 'Loading',
        },
    ]

    const [selected_1, setSelected_1] = React.useState<string>('')
    const [selected_2, setSelected_2] = React.useState<string>('')
    const [selected_3, setSelected_3] = React.useState<string>('')

    const handleChange_1 = (value: string) => {
        console.log('handleChange value 1:', value)
        setSelected_1(value)
    }
    const handleChange_2 = (value: string) => {
        console.log('handleChange value 2:', value)
        setSelected_2(value)
    }
    const handleChange_3 = (value: string) => {
        console.log('handleChange value 3:', value)
        setSelected_3(value)
    }

    return {
        dataList: data,
        value_1: selected_1,
        value_2: selected_2,
        value_3: selected_3,
        onChange_1: handleChange_1,
        onChange_2: handleChange_2,
        onChange_3: handleChange_3,
    }
}

export default useRadioGroup
